import { COBROWSE_KEY } from '../constants';
import { User } from '../slices/users';

export async function startCobrowse(user: User) {
  if (import.meta.env.MODE !== 'production') {
    return;
  }

  if (!COBROWSE_KEY) {
    console.warn('Cobrowse key is not defined. Cobrowse will not be initialized.');
    return;
  }

  const { default: CobrowseIO } = await import('cobrowse-sdk-js');

  CobrowseIO.license = COBROWSE_KEY;
  CobrowseIO.customData = {
    user_id: String(user.id),
    device_name: `Front #${user.id}`,
    user_email: user.email || '',
  };
  try {
    await CobrowseIO.start();
  } catch (error) {
    console.error('Failed to start Cobrowse:', error);
  }
}

export async function stopCobrowse() {
  if (import.meta.env.MODE !== 'production') {
    return;
  }

  const { default: CobrowseIO } = await import('cobrowse-sdk-js');

  try {
    await CobrowseIO.stop();
  } catch (error) {
    console.error('Failed to stop Cobrowse:', error);
  }
}
